/**
 * @param const ARTICLE_INDEX is used because opoint backend starts with 4
 * */
export const ARTICLE_COLORBAR_OFFSET = 3
